module.exports = __webpack_public_path__ + "media/images/close-light-7e542d76964ffba507f2d371d23f5dce.svg";